import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MemberCodeOutput } from 'pco-product-service-internal-consumer';
import { getMemberCodeThunk } from 'reducers/memberCodeStatusReducer';

export const initialMemberCodeState: MemberCodeOutput = {
  code: '',
  activationDate: undefined,
  generationDate: undefined,
  expirationDate: undefined,
  revocationDate: undefined,
  status: undefined,
  rmName: '',
};

const memberCodeSlice = createSlice({
  name: 'MEMBER_CODE',
  initialState: initialMemberCodeState,
  reducers: {
    setMemberCode: (state, action: PayloadAction<MemberCodeOutput>) => action.payload,
  },
  extraReducers: (builder) => {
    // todo check if needed
    // builder.addCase(generateMemberCodeThunk.fulfilled,(state, action) => {
    //   return {...state, ...action.payload}
    // })

    builder.addCase(getMemberCodeThunk.fulfilled, (state, action) => {
      return { ...state, ...action.payload };
    });
  },
});

export const { setMemberCode } = memberCodeSlice.actions;
export default memberCodeSlice.reducer;
